export default {
  "newsCard": {
    "linkText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr lesen"])}
  },
  "paginationInfo": {
    "pieceOne": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es werden die Beiträge"])},
    "pieceTwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bis"])},
    "pieceThree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["von insgesamt"])},
    "pieceFour": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["angezeigt."])}
  }
}